import { render, staticRenderFns } from "./SaveTemplateModal.vue?vue&type=template&id=5c6da8e0&scoped=true"
import script from "./SaveTemplateModal.vue?vue&type=script&lang=js"
export * from "./SaveTemplateModal.vue?vue&type=script&lang=js"
import style0 from "./SaveTemplateModal.vue?vue&type=style&index=0&id=5c6da8e0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6da8e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c6da8e0')) {
      api.createRecord('5c6da8e0', component.options)
    } else {
      api.reload('5c6da8e0', component.options)
    }
    module.hot.accept("./SaveTemplateModal.vue?vue&type=template&id=5c6da8e0&scoped=true", function () {
      api.rerender('5c6da8e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/quoteBuilder/components/SaveTemplateModal.vue"
export default component.exports